<script>
  export let exercise
  export let reorderHandleMouseDown = () => {}
  export let disableReordering = false

  import { createEventDispatcher } from 'svelte'
  import { tooltipable } from './tooltipable.js'
  import { deepClone } from '../utils.js'

  export let editMode = false
  let orgExercise = deepClone(exercise)

  const dispatch = createEventDispatcher()

  function handleOnSubmit() {
    if (exercise.amount <= 0) {
      // Not valid
      return
    }

    dispatch('saveExercise', exercise)
    editMode = false
  }

  function abortEditMode() {
    editMode = false
    exercise = deepClone(orgExercise)
    dispatch('abortEdit', {})
  }

  function handleDeleteExercise() {
    dispatch('deleteExercise', exercise)
  }
</script>

{#if !editMode}
  <li class="list-group-item">
    <div class="d-flex align-items-center">
      <span class="me-auto">
        {#if exercise.execution_type == 'count_based'}
          {exercise.amount}×
        {:else}
          {exercise.amount}s
        {/if}
        {exercise.exercise.name}
      </span>

      <div class="btn-group" role="group">
        <button
          type="button"
          class="btn btn-outline-primary btn-sm"
          use:tooltipable
          title="Drag to Reorder Exercises in Set"
          on:mousedown={reorderHandleMouseDown}
          on:touchstart={reorderHandleMouseDown}
          disabled={disableReordering}><i class="bi bi-arrows-expand" /></button
        >
        <button
          type="button"
          class="btn btn-outline-primary btn-sm"
          use:tooltipable
          title="Edit Exercise"
          on:click={() => {
            editMode = true
          }}><i class="bi bi-pen" /></button
        >
        <button
          type="button"
          class="btn btn-outline-danger btn-sm"
          use:tooltipable
          title="Remove Exercise"
          on:click={handleDeleteExercise}><i class="bi bi-trash" /></button
        >
      </div>
    </div>
  </li>
{:else}
  <li class="list-group-item">
    <form on:submit|preventDefault={handleOnSubmit}>
      <div class="input-group mb-2">
        <input
          type="text"
          name="amount"
          bind:value={exercise.amount}
          class="form-control"
          placeholder="Recipient's username"
        />
        <select
          class="form-select"
          name="execution_type"
          bind:value={exercise.execution_type}
        >
          <option value="count_based">Times</option>
          <option value="time_based">Seconds</option>
        </select>
      </div>

      <span>
        {exercise.exercise.name}
      </span>

      <div class="btn-group d-flex pt-2" role="group">
        <button type="submit" class="btn btn-primary btn-sm"
          ><i class="bi bi-save" /> Save Exercise</button
        >
        <button
          type="button"
          class="btn btn-secondary btn-sm"
          on:click={abortEditMode}><i class="bi bi-x" /> Abort</button
        >
      </div>
    </form>
  </li>
{/if}
